import { fetchAuthSession } from "aws-amplify/auth";

export const AmplifyConfig = {
    Auth: {
        Cognito: {
            region: process.env.REACT_APP_REGION,
            userPoolId: process.env.REACT_APP_USERPOOL_ID,
            userPoolClientId: process.env.REACT_APP_USERPOOL_CLIENT_ID,
        }
    },
    API: {
        REST: {
            "Api": {
                endpoint: process.env.REACT_APP_API_URL,
                // endpoint: process.env.REACT_APP_API_DEV_URL,
                region: process.env.REACT_APP_REGION,
                
                //Return the idToken, needed for the sessions
                custom_header: async () => {
                    const session = await fetchAuthSession();
                    const token = session.tokens?.idToken?.toString();
                    return {Authorization: `Bearer ${token}`}
                }
            }

        }
    }
}